module.exports = __webpack_public_path__ + "fi.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/fi.svg
// module id = 541
// module chunks = 0